import { createContext, useContext, useMemo, useState } from 'react';
import type { PreferredMultiple } from '../../../selector';

interface ContextValue {
  index: number;
  setIndex: (n: number) => void;
  multiple: PreferredMultiple | undefined;
  setMultiple: (m: PreferredMultiple) => void;
}

const IndustryContext = createContext<ContextValue | undefined>(undefined);

export function useIndustryContext() {
  const context = useContext(IndustryContext);
  if (context === undefined) {
    throw new Error(
      'useIndustryData must be used within a IndustryDataProvider'
    );
  }
  return context;
}

interface Props {
  children: React.ReactElement;
}
const IndustryContextProvider = (props: Props) => {
  const [index, setIndex] = useState<number>(-1);
  const [multiple, setMultiple] = useState<PreferredMultiple | undefined>();

  const value = useMemo(
    () => ({
      index,
      setIndex,
      multiple,
      setMultiple,
    }),
    [index, setIndex, multiple, setMultiple]
  );

  return (
    <IndustryContext.Provider value={value}>
      {props.children}
    </IndustryContext.Provider>
  );
};
export default IndustryContextProvider;
